import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  insights = 'insights',
  experiments = 'insights-experiments',
  resolverHealth = 'insights-resolver-health',
  pulses = 'insights-pulses',
}

enum ExternalRoutesIds {
  surface = 'surface',
}

// root route
export const insightsRouteRef = createRouteRef({ id: RoutesIds.insights });

export const rootRouteRef = insightsRouteRef;

// tab sub-routes
export const experimentsRouteRef = createSubRouteRef({
  id: RoutesIds.experiments,
  path: '/experiments',
  parent: rootRouteRef,
});

export const resolverHealthRouteRef = createSubRouteRef({
  id: RoutesIds.resolverHealth,
  path: '/resolver-health',
  parent: rootRouteRef,
});

export const pulsesRouteRef = createSubRouteRef({
  id: RoutesIds.pulses,
  path: '/pulses',
  parent: rootRouteRef,
});

// external routes to other plugins
export const surfaceRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.surface,
  params: ['id'],
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  [RoutesIds.insights]: insightsRouteRef,
  [RoutesIds.experiments]: experimentsRouteRef,
  [RoutesIds.resolverHealth]: resolverHealthRouteRef,
  [RoutesIds.pulses]: pulsesRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // external routes to other plugins
  surface: surfaceRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
